import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAnnoncesParCategorie } from "../actions/annonce.action";
import CarteAnnonces from "../components/Annonce/CarteAnnonces";
import Pagination from "../components/Annonce/Pagination";

import FiltresVehicule from "../components/AnnonceFilters/FilterVehicule";
import FiltresLogement from "../components/AnnonceFilters/FilterLogement";
import FiltresTerrain from "../components/AnnonceFilters/FilterTerrain";
import FiltresTravail from "../components/AnnonceFilters/FilterTravail";
import FiltresFormation from "../components/AnnonceFilters/FilterFormation";
import FiltresAlimentation from "../components/AnnonceFilters/FiltreAlimentation";
import FiltresAnimaux from "../components/AnnonceFilters/FilterAnimaux";
import FiltresEquipement from "../components/AnnonceFilters/FilterEquipement";
import FiltresMateriaux from "../components/AnnonceFilters/FilterMateriaux";
import FiltresPlantes from "../components/AnnonceFilters/Filterplante";
import FiltresArtisanat from "../components/AnnonceFilters/FilterArtisanat";

import { applyVehiculeFilters } from "../components/AnnoncesFiltersMetier/VehiculeFIlter";
import { applyLogementFilters } from "../components/AnnoncesFiltersMetier/LogementFilter";
import { applyTerrainFilters } from "../components/AnnoncesFiltersMetier/TerrainFilter";
import { applyTravailFilters } from "../components/AnnoncesFiltersMetier/TravailFilter";
import { applyFormationFilters } from "../components/AnnoncesFiltersMetier/FormationFilter";
import { applyAlimentationFilters } from "../components/AnnoncesFiltersMetier/AlimentationFiltre";
import { applyAnimauxFilters } from "../components/AnnoncesFiltersMetier/AnimauxFilter";
import { applyEquipementFilters } from "../components/AnnoncesFiltersMetier/EquipementFilter";
import { applyMateriauxFilters } from "../components/AnnoncesFiltersMetier/MateriauxFilter";
import { applyPlantesFilters } from "../components/AnnoncesFiltersMetier/PlanteFilter";
import { applyArtisanatFilters } from "../components/AnnoncesFiltersMetier/ArtisanatFilter";

const AnnoncesParCategorie = ({ categorieId }) => {
  const categorieIdNum = parseInt(categorieId, 10);
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const annoncesParPage = 10;

  const {
    annonces = [],
    total = 0,
    totalPages = 1,
  } = useSelector((state) => state.annonceReducer);

  useEffect(() => {
    if (categorieId) {
      dispatch(
        getAnnoncesParCategorie(categorieId, currentPage, annoncesParPage)
      );
    }
  }, [dispatch, categorieId, currentPage]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const filteredAnnonces = annonces.filter((annonce) => {
    if (categorieIdNum === 1) return applyVehiculeFilters(annonce, filters);
    if (categorieIdNum === 2) return applyLogementFilters(annonce, filters);
    if (categorieIdNum === 3) return applyTerrainFilters(annonce, filters);
    if (categorieIdNum === 5) return applyTravailFilters(annonce, filters);
    if (categorieIdNum === 10) return applyFormationFilters(annonce, filters);
    if (categorieIdNum === 6) return applyAlimentationFilters(annonce, filters);
    if (categorieIdNum === 7) return applyAnimauxFilters(annonce, filters);
    if (categorieIdNum === 8) return applyEquipementFilters(annonce, filters);
    if (categorieIdNum === 9) return applyEquipementFilters(annonce, filters);
    if (categorieIdNum === 11) return applyMateriauxFilters(annonce, filters);
    if (categorieIdNum === 12) return applyPlantesFilters(annonce, filters);    
    if (categorieIdNum === 13) return applyArtisanatFilters(annonce, filters);  
    return true;
  });

  return (
    <div className="annoncesPage">
      <div className="leftPartAnnonce">
        <div className="filtre">
          <h2>Filtres</h2>
          {categorieIdNum === 1 && (
            <FiltresVehicule
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 2 && (
            <FiltresLogement
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 3 && (
            <FiltresTerrain
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 5 && (
            <FiltresTravail
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 10 && (
            <FiltresFormation
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 6 && (
            <FiltresAlimentation
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 7 && (
            <FiltresAnimaux
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 8 && (
            <FiltresEquipement
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 9 && (
            <FiltresEquipement
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 11 && (
            <FiltresMateriaux
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 12 && (
            <FiltresPlantes
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
          {categorieIdNum === 13 && (
            <FiltresArtisanat
              annonces={annonces}
              filters={filters}
              onChange={handleFilterChange}
            />
          )}
        </div>
      </div>

      <div className="rightPart">
        <div className="annonces-container">
          {filteredAnnonces.length > 0 ? (
            <>
              {filteredAnnonces.map((annonce) => (
                <CarteAnnonces
                  key={annonce._id}
                  annonce={annonce}
                  utilisateurId={annonce.utilisateur}
                />
              ))}
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </>
          ) : (
            <p>Aucune annonce disponible.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnnoncesParCategorie;
